import { registerQuery } from 'data-fetching-client';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
// BO TODO - add the isQA local proxy check
const fetchBusinessObjectives = ({
  highlightedProducts,
  highlightedFeatureType,
  langLocale
}) => {
  const i18nLangLocale = langLocale || 'en-us';
  return noAuthHttp.get('/feature/store/v1/business-objectives/by-api-names', {
    query: {
      productApiNames: highlightedProducts,
      highlightedFeatureType,
      i18nLangLocale
    }
  });
};
export const GET_BUSINESS_OBJECTIVES = registerQuery({
  fieldName: 'businessObjectives',
  args: ['highlightedProducts', 'highlightedFeatureType', 'langLocale'],
  fetcher({
    highlightedProducts,
    highlightedFeatureType,
    langLocale
  }) {
    return fetchBusinessObjectives({
      highlightedFeatureType,
      highlightedProducts,
      langLocale
    });
  }
});